import React from 'react';
import { AccountPanelTypes } from '../../AccountPanelTypes';
import { weakKey } from '../../../../utilities/weakKey';

export const NormalDropDown = ({
  dropDownList,
  defaultValue,
  updateSelectedValue,
  label,
}: AccountPanelTypes.TDropDown) => {
  return (
    <div className="dropDownContainer">
      <p className="dropDownLabel">{label}</p>
      {defaultValue ? (
        <select
          id="users"
          className="dropDown"
          value={defaultValue}
          onChange={updateSelectedValue}
        >
          {dropDownList.map(
            ({ id, label: dropDownLabel }: { id: string; label: string }) => {
              return (
                <option value={id} key={weakKey({ id })}>
                  {dropDownLabel}
                </option>
              );
            }
          )}
        </select>
      ) : (
        <></>
      )}
    </div>
  );
};
